import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import Row1ExtraInfo from './Row1ExtraInfo';
import Row2ExtraInfo from './Row2ExtraInfo';

import AppContext from '../../context';
import { ContextName } from '../../appContext/contextName';

import Container from '../Container';

import {
  footer,
  lower,
  copyright,
  rule,
  narrowContainer,
  extraPadding,
} from './styles.module.css';

function Footer({
  addBottomSpaceOnMobile,
  narrow,
  showExtendedFooter = false,
}) {
  const appContext = useContext(AppContext);
  const userSelectedLocale = appContext[ContextName.USER_SELECTED_LOCALE];

  return (
    <footer className={footer}>
      {showExtendedFooter && <Row1ExtraInfo narrow={narrow} />}
      <hr className={rule} />
      <Container className={narrow ? narrowContainer : ''}>
        <div
          className={[lower, addBottomSpaceOnMobile ? extraPadding : ''].join(
            ' ',
          )}
        >
          <div className={copyright}>
            <span>&copy; Let&#39;s Do This {new Date().getFullYear()}</span>
          </div>
          {showExtendedFooter && (
            <Row2ExtraInfo userSelectedLocale={userSelectedLocale} />
          )}
        </div>
      </Container>
    </footer>
  );
}

Footer.propTypes = {
  narrow: PropTypes.bool,
  addBottomSpaceOnMobile: PropTypes.bool,
};

Footer.defaultProps = {
  narrow: false,
  addBottomSpaceOnMobile: false,
};

export default Footer;
